import { useEffect } from 'react';

import moment from 'moment';

import { ISeason, ISeasonsStore } from '../../../../store/seasons/store';

import { getCurrentSeason } from '../Utils/getCurrentSeason';

interface IUsePlayerSeasons {
  clubId: string;
  getSeasons: any;
  seasons: ISeasonsStore;
  seasonId: string;
}

export const usePlayerSeasons = (props: IUsePlayerSeasons): [any, ISeason | undefined] => {
  const { clubId, getSeasons, seasons, seasonId } = props;

  const clubSeasons = (seasons[Number(clubId)] ? seasons[Number(clubId)].seasons : []).sort(
    (s1, s2) => moment(s2.start).diff(moment(s1.start), 'minutes')
  );

  const currentSeason = clubSeasons.length
    ? !!seasonId
      ? clubSeasons.find(s => s.id === Number(seasonId))
      : getCurrentSeason(clubSeasons)
    : undefined;

  useEffect(() => {
    getSeasons(Number(clubId));
  }, [clubId]);

  return [clubSeasons, currentSeason];
};
